"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class CertificazioneApi extends runtime.BaseAPI {
    /**
     * Certificazione dei contatti del cliente con validazione dell\'sms inviato (Auth roles: User)
     */
    apiCertificazioneCertificaContattoGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.tokenCellulare === null || requestParameters.tokenCellulare === undefined) {
                throw new runtime.RequiredError('tokenCellulare', 'Required parameter requestParameters.tokenCellulare was null or undefined when calling apiCertificazioneCertificaContattoGet.');
            }
            const queryParameters = {};
            if (requestParameters.tokenCellulare !== undefined) {
                queryParameters['tokenCellulare'] = requestParameters.tokenCellulare;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/certifica-contatto`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CertificazioneContattoDtoFromJSON(jsonValue));
        });
    }
    /**
     * Certificazione dei contatti del cliente con validazione dell\'sms inviato (Auth roles: User)
     */
    apiCertificazioneCertificaContattoGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneCertificaContattoGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Dettaglio delle certificazioni per un dato NDG (Auth roles: Admin)
     */
    apiCertificazioneCertificazioniNdgDettaglioGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ndg === null || requestParameters.ndg === undefined) {
                throw new runtime.RequiredError('ndg', 'Required parameter requestParameters.ndg was null or undefined when calling apiCertificazioneCertificazioniNdgDettaglioGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/certificazioni/{ndg}/dettaglio`.replace(`{${"ndg"}}`, encodeURIComponent(String(requestParameters.ndg))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CertificazioniDettaglioDtoFromJSON(jsonValue));
        });
    }
    /**
     * Dettaglio delle certificazioni per un dato NDG (Auth roles: Admin)
     */
    apiCertificazioneCertificazioniNdgDettaglioGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneCertificazioniNdgDettaglioGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Elenco certificazioni dato un particolare NDG (Auth roles: Admin)
     */
    apiCertificazioneCertificazioniNdgGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ndg === null || requestParameters.ndg === undefined) {
                throw new runtime.RequiredError('ndg', 'Required parameter requestParameters.ndg was null or undefined when calling apiCertificazioneCertificazioniNdgGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/certificazioni/{ndg}`.replace(`{${"ndg"}}`, encodeURIComponent(String(requestParameters.ndg))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.CertificazioneDtoFromJSON));
        });
    }
    /**
     * Elenco certificazioni dato un particolare NDG (Auth roles: Admin)
     */
    apiCertificazioneCertificazioniNdgGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneCertificazioniNdgGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Informazioni sulla certificazione in base al token email ricevuto dal cliente. Il servizio può essere utilizzato solo dal FE (Auth roles: User)
     */
    apiCertificazioneDettaglioGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/dettaglio`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CertificazioneUtenteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Informazioni sulla certificazione in base al token email ricevuto dal cliente. Il servizio può essere utilizzato solo dal FE (Auth roles: User)
     */
    apiCertificazioneDettaglioGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneDettaglioGetRaw();
            return yield response.value();
        });
    }
    /**
     * Avvio del processo di certificazione per l\'id selezionato (Auth roles: Admin)
     */
    apiCertificazioneIdAvvioGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiCertificazioneIdAvvioGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/{id}/avvio`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CertificazioneEmailDtoFromJSON(jsonValue));
        });
    }
    /**
     * Avvio del processo di certificazione per l\'id selezionato (Auth roles: Admin)
     */
    apiCertificazioneIdAvvioGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneIdAvvioGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Restituisce i log della chimata di salvataggio dei dati aggiuntivi di Cedacri (Auth roles: Admin)
     */
    apiCertificazioneIdCertificazioneLogAnagrafeCedacriGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idCertificazione === null || requestParameters.idCertificazione === undefined) {
                throw new runtime.RequiredError('idCertificazione', 'Required parameter requestParameters.idCertificazione was null or undefined when calling apiCertificazioneIdCertificazioneLogAnagrafeCedacriGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/{idCertificazione}/log-anagrafe-cedacri`.replace(`{${"idCertificazione"}}`, encodeURIComponent(String(requestParameters.idCertificazione))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.LogCertificazioneAnagrafeCedacriDtoFromJSON));
        });
    }
    /**
     * Restituisce i log della chimata di salvataggio dei dati aggiuntivi di Cedacri (Auth roles: Admin)
     */
    apiCertificazioneIdCertificazioneLogAnagrafeCedacriGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneIdCertificazioneLogAnagrafeCedacriGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Informazioni sulla certificazione da id certificazione (Auth roles: Admin)
     */
    apiCertificazioneIdDettaglioGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiCertificazioneIdDettaglioGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/{id}/dettaglio`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.DettaglioCertificazioneDtoFromJSON(jsonValue));
        });
    }
    /**
     * Informazioni sulla certificazione da id certificazione (Auth roles: Admin)
     */
    apiCertificazioneIdDettaglioGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneIdDettaglioGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Preview del processo di certificazione per l\'email selezionata (Auth roles: Admin)
     */
    apiCertificazionePreviewPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/preview`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.PreviewEmailRequestDtoToJSON(requestParameters.previewEmailRequestDto),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CertificazioneEmailDtoFromJSON(jsonValue));
        });
    }
    /**
     * Preview del processo di certificazione per l\'email selezionata (Auth roles: Admin)
     */
    apiCertificazionePreviewPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazionePreviewPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Ricerca delle certificazioni in base ai filtri impostati. I risultati sono paginati (Auth roles: Admin)
     */
    apiCertificazioneRicercaPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Certificazione/ricerca`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.DataProcessDtoToJSON(requestParameters.dataProcessDto),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CertificazioneDtoPagedListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Ricerca delle certificazioni in base ai filtri impostati. I risultati sono paginati (Auth roles: Admin)
     */
    apiCertificazioneRicercaPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCertificazioneRicercaPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.CertificazioneApi = CertificazioneApi;
